// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconLogoTock = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M11.995 21a8.94 8.94 0 005.393-1.801l-2.782-2.792c-.77.46-1.66.72-2.611.72-2.842 0-5.143-2.32-5.143-5.172a5.19 5.19 0 013.862-5.013V3C6.352 3.63 3 7.402 3 11.955 2.99 16.948 7.022 21 11.995 21m7.214-3.622A9.02 9.02 0 0021 11.955C21 7.392 17.648 3.62 13.286 3v3.952a5.18 5.18 0 013.862 5.013c0 .96-.26 1.851-.71 2.621z"
    />
  );
export default SvgIconLogoTock;
